/**
 * Cart Upsell Manager
 * Handles Swiper initialization and AJAX add-to-cart for dynamically loaded
 * product recommendations in the cart drawer.
 *
 * This script runs at the document level so it persists across cart drawer
 * re-renders (which replace innerHTML of cart-items-component).
 */
(function () {
  'use strict';

  var currentSwiper = null;

  function initCartUpsell() {
    var swiperEl = document.getElementById('CartUpsellSwiper');
    if (!swiperEl || typeof window.Swiper === 'undefined') return;

    // Avoid double-init
    if (swiperEl.dataset.swiperInitialized === 'true') return;
    swiperEl.dataset.swiperInitialized = 'true';

    // Destroy previous instance if exists
    if (currentSwiper && typeof currentSwiper.destroy === 'function') {
      currentSwiper.destroy(true, true);
      currentSwiper = null;
    }

    currentSwiper = new window.Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      slidesOffsetAfter: 12,
      breakpoints: {
        750: {
          slidesOffsetAfter: 24
        }
      },
      navigation: {
        nextEl: '#CartUpsellNext',
        prevEl: '#CartUpsellPrev',
      },
    });

    bindAddToCartButtons(swiperEl);
    bindChooseButtons(swiperEl);
  }

  function bindAddToCartButtons(container) {
    container.querySelectorAll('.cart-upsell-card__btn--add').forEach(function (btn) {
      // Prevent duplicate listeners
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId || btn.disabled) return;

        btn.disabled = true;
        var originalHTML = btn.innerHTML;
        btn.innerHTML =
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" style="animation:cart-upsell-spin 0.6s linear infinite"><circle cx="6" cy="6" r="5" stroke="#ccc" stroke-width="1.5" fill="none"/><path d="M6 1A5 5 0 0 1 11 6" stroke="#000" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg>';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (response) {
            if (response.status) {
              console.error('Cart add error:', response.description);
              btn.disabled = false;
              btn.innerHTML = originalHTML;
              return;
            }

            // Update cart count bubble
            updateCartBubble();

            // Refresh cart drawer items without closing/navigating
            refreshCartDrawerItems();

            btn.disabled = false;
            btn.innerHTML = originalHTML;
          })
          .catch(function (err) {
            console.error('Cart add error:', err);
            btn.disabled = false;
            btn.innerHTML = originalHTML;
          });
      });
    });
  }

  function bindChooseButtons(container) {
    container.querySelectorAll('.cart-upsell-card__btn--choose').forEach(function (btn) {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var productUrl = btn.getAttribute('data-product-url') || btn.getAttribute('href');
        if (!productUrl) return;

        // Show loading state
        var originalHTML = btn.innerHTML;
        btn.innerHTML =
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" style="animation:cart-upsell-spin 0.6s linear infinite"><circle cx="6" cy="6" r="5" stroke="#ccc" stroke-width="1.5" fill="none"/><path d="M6 1A5 5 0 0 1 11 6" stroke="#000" stroke-width="1.5" stroke-linecap="round" fill="none"/></svg>';

        // Fetch the product page
        fetch(productUrl)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            // Extract the product grid content (same selector the theme uses)
            var productGrid = doc.querySelector('[data-product-grid-content]');
            var modalContent = document.getElementById('quick-add-modal-content');
            var dialogComponent = document.getElementById('quick-add-dialog');

            if (productGrid && modalContent && dialogComponent) {
              // Inject the product content into the modal
              modalContent.innerHTML = productGrid.innerHTML;

              // Open the quick-add dialog
              if (typeof dialogComponent.showDialog === 'function') {
                dialogComponent.showDialog();
              }
            } else {
              // Fallback: navigate to product page if modal elements not found
              window.location.href = productUrl;
            }
          })
          .catch(function (err) {
            console.error('Quick add fetch error:', err);
            window.location.href = productUrl;
          })
          .finally(function () {
            btn.innerHTML = originalHTML;
          });
      });
    });
  }

  function updateCartBubble() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        // Update all cart bubbles to reflect new item count
        document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('hidden', cart.item_count === 0);
        });

        // Dispatch theme's cart:update event so CartIcon and other elements sync correctly
        var cartEvent = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'cart-upsell',
            data: {
              source: 'cart-upsell',
              itemCount: cart.item_count,
            },
          },
        });
        document.dispatchEvent(cartEvent);
      })
      .catch(function (err) {
        console.error('Failed to update cart bubble:', err);
      });
  }

  function refreshCartDrawerItems() {
    var cartItems = document.querySelector('cart-items-component[data-drawer]');
    if (!cartItems || !cartItems.dataset.sectionId) return;

    var sectionId = cartItems.dataset.sectionId;

    fetch('/?sections=' + sectionId)
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        if (!sections[sectionId]) return;

        var tmp = document.createElement('div');
        tmp.innerHTML = sections[sectionId];

        // Only update the cart items list and summary, NOT the entire component
        var newItems = tmp.querySelector('.cart-drawer__items');
        var newSummary = tmp.querySelector('.cart-drawer__summary');
        var currentItems = cartItems.querySelector('.cart-drawer__items');
        var currentSummary = cartItems.querySelector('.cart-drawer__summary');

        if (newItems && currentItems) {
          currentItems.innerHTML = newItems.innerHTML;
        }
        if (newSummary && currentSummary) {
          currentSummary.innerHTML = newSummary.innerHTML;
        }

        // Update product-recommendations data-product-id if the first item's product ID changed
        var newRecs = tmp.querySelector('product-recommendations');
        var currentRecs = document.getElementById('CartDrawerUpsell');
        if (newRecs && currentRecs) {
          var newProductId = newRecs.getAttribute('data-product-id');
          var currentProductId = currentRecs.getAttribute('data-product-id');
          if (newProductId !== currentProductId) {
            currentRecs.classList.remove('hidden');
            currentRecs.removeAttribute('data-recommendations-performed');
            currentRecs.setAttribute('data-product-id', newProductId);
          }
        }
        
        // Trigger cart events so other components (like free shipping) can update
        document.dispatchEvent(new Event('cart:updated'));
        document.dispatchEvent(new Event('theme:cart:updated'));
      })
      .catch(function (err) {
        console.error('Cart refresh error:', err);
      });
  }

  // Bind the built-in add/choose handlers on the compact (no-Swiper) add-ons list.
  // initCartUpsell() only binds inside #CartUpsellSwiper, which the compact drawer
  // doesn't render, so bind directly on the recommendations container here.
  function bindUpsellButtons() {
    var container = document.getElementById('CartDrawerUpsell');
    if (!container || !container.querySelector('.cart-upsell-card')) return;
    bindAddToCartButtons(container);
    bindChooseButtons(container);
  }

  // Watch the stable cart drawer root for product-recommendations content.
  function setupPersistentObserver() {
    var cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;

    var observer = new MutationObserver(function () {
      var swiperEl = cartDrawer.querySelector('#CartUpsellSwiper');
      if (swiperEl && swiperEl.dataset.swiperInitialized !== 'true') {
        // Small delay to ensure DOM is fully settled
        setTimeout(initCartUpsell, 50);
      }
      // Compact list (no Swiper): bind add-to-cart / choose handlers. Idempotent
      // via each button's data-bound flag.
      bindUpsellButtons();
    });

    // The component stays mounted while its cart contents are re-rendered.
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  // Expose the cart refresh helpers so the in-drawer quick view (cart-quick-view.js) can
  // reuse the exact same refresh path after adding a variant, keeping one source of truth.
  window.VPCartUpsell = window.VPCartUpsell || {};
  window.VPCartUpsell.refreshCartDrawerItems = refreshCartDrawerItems;
  window.VPCartUpsell.updateCartBubble = updateCartBubble;

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupPersistentObserver();
      setTimeout(initCartUpsell, 200);
      setTimeout(bindUpsellButtons, 250);
    });
  } else {
    setupPersistentObserver();
    setTimeout(initCartUpsell, 200);
    setTimeout(bindUpsellButtons, 250);
  }
})();

// Shipping protection tooltip
(function () {
  if (window.ascTooltipSetupDone) return;
  window.ascTooltipSetupDone = true;

  const initTooltipObserver = () => {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;

    const observer = new MutationObserver(() => {
      cartDrawer.querySelectorAll('[class^="asc-body-"]').forEach((body) => {
        const span = body.querySelector('.asc-shipping-protection-subtitle-text');
        const link = body.querySelector('a[class^="asc-link-"]');

        let customBox = body.querySelector('.asc-custom-tooltip');
        if (!customBox) {
          customBox = document.createElement('div');
          customBox.className = 'asc-custom-tooltip';

          const textSpan = document.createElement('span');
          textSpan.className = 'asc-custom-text';

          const aLink = document.createElement('a');
          aLink.className = 'asc-custom-link';
          aLink.target = '_blank';

          const closeBtn = document.createElement('div');
          closeBtn.className = 'asc-tooltip-close';
          closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">\n<path d="M4.66675 4.66669L11.3334 11.3334M4.66675 11.3334L11.3334 4.66669" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n</svg>`;

          customBox.appendChild(textSpan);
          customBox.appendChild(document.createTextNode(' '));
          customBox.appendChild(aLink);
          customBox.appendChild(closeBtn);

          body.appendChild(customBox);
        }

        if (span) {
          const textSpan = customBox.querySelector('.asc-custom-text');
          if (textSpan && textSpan.textContent !== span.textContent) {
            textSpan.textContent = span.textContent;
          }
        }

        if (link) {
          const aLink = customBox.querySelector('.asc-custom-link');
          if (aLink) {
            const linkText = link.textContent || link.innerText;
            const linkHref = link.getAttribute('href');
            if (aLink.textContent !== linkText) aLink.textContent = linkText;
            if (aLink.getAttribute('href') !== linkHref) aLink.setAttribute('href', linkHref);
          }
        }
      });
    });
    observer.observe(cartDrawer, { childList: true, subtree: true, characterData: true, attributes: true });

    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('.asc-tooltip-close');
      if (closeBtn) {
        e.preventDefault();
        e.stopPropagation();
        const bodyEl = closeBtn.closest('[class^="asc-body-"]');
        if (bodyEl) bodyEl.classList.remove('is-active');
        return;
      }

      const bodyEl = e.target.closest('[class^="asc-body-"]');
      if (bodyEl) {
        if (e.target.closest('a[class^="asc-link-"]') || e.target.closest('a.asc-custom-link')) return;
        e.preventDefault();
        if (bodyEl.classList.contains('is-active')) {
          bodyEl.classList.remove('is-active');
        } else {
          document
            .querySelectorAll('[class^="asc-body-"].is-active')
            .forEach((el) => el.classList.remove('is-active'));
          bodyEl.classList.add('is-active');
        }
      } else {
        document.querySelectorAll('[class^="asc-body-"].is-active').forEach((el) => el.classList.remove('is-active'));
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTooltipObserver);
  } else {
    initTooltipObserver();
  }
})();
